/**
 * Empty chart fixtures — chart content comes from Medplum (`medplumChartBundle`, episode-scoped hooks).
 */
import type {
  AdminNote,
  Appointment,
  Assessment,
  AssessmentDataPoint,
  ClinicalNote,
  ClientDocument,
  CompletedForm,
  DischargeSummary,
  Episode,
  HealthMetric,
  Medication,
  NoteSnippet,
  NoteTemplate,
  OutstandingForm,
  ProviderAssociation,
  Task,
  TreatmentPlan,
} from './types';

export const mockAppointments: Appointment[] = [];
export const mockClinicalNotes: ClinicalNote[] = [];
export const mockProviderAssociations: ProviderAssociation[] = [];
export const mockTreatmentPlans: TreatmentPlan[] = [];
export const mockEpisodes: Episode[] = [];
export const mockDischargeSummaries: DischargeSummary[] = [];
export const mockAssessments: Assessment[] = [];
export const mockOutstandingForms: OutstandingForm[] = [];
export const mockTasks: Task[] = [];
export const mockAssessmentTrends: AssessmentDataPoint[] = [];
export const mockHealthMetrics: HealthMetric[] = [];
export const mockCompletedForms: CompletedForm[] = [];
export const mockClientDocuments: ClientDocument[] = [];
export const availableFormTypes: string[] = [];
export const mockMedications: Medication[] = [];
export const mockAdminNotes: AdminNote[] = [];
export const mockNoteTemplates: NoteTemplate[] = [];
export const mockNoteSnippets: NoteSnippet[] = [];
